import OptInAdornment from './OptInAdornment';

export default OptInAdornment;
